import React, { createContext, useState } from "react";

export const TempEventContext = createContext({});

// The Temp Event provider contains temporary events triggered on the frontend
// Use this provider when an element needs to trigger something once for the session
// For example, when a streak badge is received, create an event here and retrieve it once
export const TempEventProvider: React.FC = ({ children }) => {
  const [showStreakAnimation, setShowStreakAnimation] = useState(false);
  const [showStreakModal, setShowStreakModal] = useState(false);
  const [isSolverLoaded, setIsSolverLoaded] = useState(false);
  const [checkWorkTriggered, setCheckWorkTriggered] = useState(false);
  const [dismissedStudentModeBanner, setDismissedStudentModeBanner] = useState(false);

  return (
    <TempEventContext.Provider
      value={{
        showStreakAnimation,
        setShowStreakAnimation,
        showStreakModal,
        setShowStreakModal,
        isSolverLoaded,
        setIsSolverLoaded,
        checkWorkTriggered,
        setCheckWorkTriggered,
        dismissedStudentModeBanner,
        setDismissedStudentModeBanner,
      }}>
      {children}
    </TempEventContext.Provider>
  );
};
